import React from 'react';
import { Form, Input, Button } from 'antd';

interface MaintenanceTypeFormProps {
  form: any;
  initialValues?: any;
  onFinish: (values: any) => void;
  loading?: boolean;
  submitText?: string;
  hideFields?: string[];
}

const MaintenanceTypeForm: React.FC<MaintenanceTypeFormProps> = ({
  form,
  initialValues = {},
  onFinish,
  loading = false,
  submitText = 'Lưu',
  hideFields = [],
}) => {
  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      {!hideFields.includes('name') && (
        <Form.Item 
          name="name" 
          label="Tên loại bảo trì" 
          rules={[{ required: true, message: 'Nhập tên loại bảo trì!' }]}
        > 
          <Input 
            className="ams-input" 
            placeholder="Tên loại bảo trì" 
            size="large" 
            style={{ width: '100%', borderRadius: 8, height: 40 }} 
          />
        </Form.Item>
      )}
      
      {!hideFields.includes('description') && (
        <Form.Item name="description" label="Mô tả">
          <Input 
            className="ams-input" 
            placeholder="Mô tả" 
            size="large" 
            style={{ width: '100%', borderRadius: 8, height: 40 }} 
          />
        </Form.Item>
      )}
      
      <Form.Item style={{ marginBottom: 0 }}>
        <Button 
          className="ams-btn" 
          type="primary" 
          htmlType="submit" 
          size="large" 
          loading={loading}
          style={{ width: '100%', borderRadius: 8, height: 40 }}
        >
          {submitText}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default MaintenanceTypeForm; 